import * as SurveyCore from "survey-core";

export default function SaveButton(surveyCreator: any) {
  // @ts-ignore
  const isVisible: boolean = new SurveyCore.ComputedUpdater<boolean | undefined>(() => {
    return surveyCreator.activeTab === "designer" || surveyCreator.activeTab === "theme";
  });
  surveyCreator.toolbar.actions.find((a: any) => a.id === "svd-save").visible = isVisible;

  const saveThemeAction = surveyCreator.toolbar.actions.find((a: any) => a.id === "svd-save-theme");
  saveThemeAction.visible = new SurveyCore.ComputedUpdater<boolean | undefined>(() => {
    return false;
  });
}
